<template>
  <v-container fluid class="pa-4">
    <v-layout row wrap>
      <v-flex cols="12">
        <!-- Main Card -->
        <v-card v-if="user">
          <v-card-title class="text-h5 font-weight-bold">
            <v-icon left color="primary">mdi-account-circle</v-icon>
            <div>User Details</div>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-layout row wrap>
              <v-flex xs12>
                <v-list two-line class="bg-transparent">
                  <!-- Name -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-account</v-icon>
                    <span class="font-weight-bold mr-2">Name:</span>
                    <div>
                      <span class="text-h6">{{ user.name || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Email -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-email</v-icon>
                    <span class="font-weight-bold mr-2">Email:</span>
                    <div>
                      <span class="text-h6">{{ user.emailId || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- User ID -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-account</v-icon>
                    <span class="font-weight-bold mr-2">User ID:</span>
                    <div>
                      <span class="text-h6">{{ user.id || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Site Name -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4"
                      >mdi-office-building</v-icon
                    >
                    <span class="font-weight-bold mr-2">Site Name:</span>
                    <div>
                      <span class="text-h6">{{ user.siteName || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Phone -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                    <span class="font-weight-bold mr-2"
                      >Phone in ManageEngine:</span
                    >
                    <div>
                      <span class="text-h6">{{ user.phone || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Room -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-domain</v-icon>
                    <span class="font-weight-bold mr-2">Room:</span>
                    <div>
                      <span class="text-h6">{{ user.room || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <div v-if="!editMode">
                    <!-- Phone Mapped -->
                    <v-list-tile class="px-0">
                      <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                      <span class="font-weight-bold mr-2">Phone Mapped:</span>
                      <div>
                        <span class="text-h6">{{
                          user.phoneMapped || "—"
                        }}</span>
                      </div>
                    </v-list-tile>

                    <v-divider></v-divider>

                    <!-- Extension -->
                    <v-list-tile class="px-0">
                      <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                      <span class="font-weight-bold mr-2">Extension:</span>
                      <div>
                        <span class="text-h6">{{ user.extension || "—" }}</span>
                      </div>
                    </v-list-tile>

                    <v-divider></v-divider>
                  </div>
                  <div v-else>
                    <v-form ref="formEdit">
                      <!--Edit Phone Mapped -->
                      <v-list-tile class="px-0">
                        <v-icon color="blue-grey" class="mr-4"
                          >mdi-phone</v-icon
                        >
                        <span class="font-weight-bold mr-2">Phone Mapped:</span>

                        <div class="d-flex align-center ml-4">
                          <v-text-field
                            clearable
                            outlined
                            v-model="edit.phone"
                            hint="No re-mapping required for existing ManageEngine phone"
                            placeholder="Enter a 10-digit number"
                            type="text"
                            :rules="[rules.phone]"
                          ></v-text-field>
                        </div>
                      </v-list-tile>

                      <v-divider></v-divider>

                      <!--Edit Extension -->
                      <v-list-tile class="px-0">
                        <v-icon color="blue-grey" class="mr-4"
                          >mdi-phone</v-icon
                        >
                        <span class="font-weight-bold mr-2">Extension:</span>

                        <div class="d-flex align-center ml-4">
                          <v-text-field
                            clearable
                            v-model="edit.extension"
                            placeholder="Enter a 5-digit number"
                            type="text"
                            :rules="[rules.extension]"
                          ></v-text-field>
                        </div>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </v-form>
                    <p>Alll other information is editable only be the <a href="https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=user" target="_blank">ManageEngine website.</a></p>
                  </div>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0">
            <v-spacer></v-spacer>
            <div v-if="!editMode">
              <v-btn
                color="default"
                small
                @click="closeDialog"
                :dark="true"
                :disabled="false"
                >Close</v-btn
              >
              <v-btn small color="success" @click="enterEditMode">Edit</v-btn>
            </div>
            <div v-else>
              <v-btn
                color="default"
                small
                @click="editMode = false"
                :dark="true"
                :disabled="false"
                >Cancel</v-btn
              >
              <v-btn
                small
                :loading="processing"
                color="success"
                @click="saveChanges"
                >Save Changes</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      user: this.initialData.user || null,
      editMode: false,
      processing: false,
      manageEngineUsers: [],
      edit: {
        phone: null,
        extension: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        extension: (v) => !v || /^\d{5}$/.test(v) || "Enter a valid extension",
        phone: (v) =>
          !v ||
          /^\d{10}$/.test(v) ||
          "Enter a valid phone without dashes or parentheses",
      },
    };
  },

  created() {
    //console.log("User data:", this.user);
  },

  methods: {
    closeDialog() {
      this.$emit("closeUserDialog");
    },
    initializeEdit() {
      if (!this.user) return;
      this.edit.phone = this.user.phoneMapped;
      this.edit.extension = this.user.extension;
      this.edit.room = this.user.room;
    },
    enterEditMode() {
      this.initializeEdit();
      this.editMode = true;
    },
    async saveChanges() {
      if (!this.$refs.formEdit.validate(true)) return;

      if (
        this.edit.phone == this.user.phoneMapped &&
        this.edit.extension == this.user.extension &&
        this.edit.room == this.user.room
      ) {
        return this.$notify({
          group: "notification",
          text: "No changes detected",
          type: "info",
        });
      }
      await this.loadManageEngineUsers();

      const hasPhone =
        this.edit.phone !== null &&
        this.edit.phone !== undefined &&
        this.edit.phone !== "";

      const existPhone = hasPhone
        ? this.manageEngineUsers.find((u) => u.phoneMapped === this.edit.phone)
        : null;

      //   const existPhone = this.manageEngineUsers.find(
      //     (u) => u.phoneMapped == this.edit.phone
      //   );

      if (existPhone && existPhone.id !== this.user.id) {
        return this.$notify({
          group: "notification",
          text: `Phone ${this.edit.phone} is already mapped to ${
            existPhone.name
          } ${existPhone.emailId}`,
          type: "error",
        });
      }

      const hasExtension =
        this.edit.extension !== null &&
        this.edit.extension !== undefined &&
        this.edit.extension !== "";

      const existExt = hasExtension
        ? this.manageEngineUsers.find(
            (u) => u.extension === this.edit.extension
          )
        : null;

      if (existExt && existExt.id !== this.user.id) {
        return this.$notify({
          group: "notification",
          text: `Extension ${this.edit.extension} is already mapped to ${
            existExt.name
          } ${existExt.emailId}`,
          type: "error",
        });
      }

      this.processing = true;
      try {
        await this.$http.put(
          `api/ManageengineUsers/UpsertUser/${this.user.id}`,
          {
            Id: this.user.id,
            Extension: this.edit.extension
              ? this.edit.extension
              : this.user.extension
              ? "clear"
              : null,
            PhoneMapped: this.edit.phone
              ? this.edit.phone
              : this.user.phoneMapped
              ? "clear"
              : null,
          }
        );
        this.$notify({
          group: "notification",
          text: "User updated successfully",
          type: "success",
        });
        this.editMode = false;
        this.$emit("saveChanges");
      } catch (error) {
      } finally {
        this.processing = false;
      }
    },
    async loadManageEngineUsers() {
      this.processing = true;
      try {
        const response = await this.$http.get(`/odata/ManageEngineUsers`);
        this.manageEngineUsers = response.value;
      } catch (error) {
        console.error(error);
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card-title {
  word-break: break-word;
}
</style>
